module.exports = __webpack_public_path__ + "static/aboutContactFront-405ce1567cb76c6cab4110e0024bacbb.png";